export default __webpack_public_path__ + "static/media/Profile.11f80f8d.png";